var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('div',{staticClass:"name"},[_vm._v(" Uppgift "+_vm._s(_vm.name)+" "),(_vm.scoreMaxMessage)?_c('span',{staticClass:"score-max"},[_vm._v(_vm._s(_vm.scoreMaxMessage))]):_vm._e(),_vm._v(": ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }